import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Pagewrapper } from "../../components";
import Row from "react-bootstrap/Row";

const Privacidade = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row>
        <Col>
          <h1 className="mt-5 text-center">Privacidade e Proteção de Dados</h1>
        </Col>
      </Row>
    <p> </p>
    <p>Na LEX Editora, a proteção dos seus dados é uma prioridade inegociável.</p>
    
    <p>Tratamos a privacidade como um compromisso ético, jurídico e tecnológico. Alinhado às melhores práticas do mercado e às exigências da Lei Geral de Proteção de Dados (LGPD).</p>
    
    <p>Coletamos apenas as informações necessárias para garantir o pleno funcionamento da plataforma, melhorar a sua experiência de pesquisa e oferecer conteúdos, serviços e funcionalidades de alta qualidade. Todo o tratamento de dados é realizado com base em finalidades legítimas, transparentes e claramente informadas.</p>
    
    <p>Empregamos medidas rigorosas de segurança para proteger seus dados contra acessos não autorizados, perdas, alterações indevidas ou qualquer forma de uso inadequado. Nossos processos são periodicamente revisados para assegurar conformidade, integridade e proteção contínua das informações.</p>
    
    <p>Seus dados jamais são vendidos ou compartilhados sem consentimento ou sem fundamento legal. Quando o compartilhamento é necessário, como em integrações tecnológicas essenciais à operação da plataforma, ele ocorre de forma controlada, contratualmente protegida e limitada ao mínimo indispensável.</p>
    
    <p>Você mantém total controle sobre suas informações. A qualquer momento, pode solicitar acesso, correção, atualização ou exclusão de dados pessoais, conforme previsto pela LGPD. Nosso time está sempre disponível para esclarecer dúvidas e atender às suas solicitações de forma ágil e transparente.</p>
    
    <p>A confiança que você deposita na LEX Editora move nosso compromisso.</p>
    
    <p>Trabalhamos diariamente para garantir que sua experiência seja segura, responsável e respeitosa em todas as etapas do uso da plataforma.</p>


    </Container>
  </Pagewrapper>
);

export default Privacidade;
